import styled, { css } from 'styled-components';
import { THEME } from '../../../../themes';
import { Subtitle1Font, Subtitle2Font } from '../../../../themes/fonts';
import { ASSETS } from '../../../../assets';

const getBackgroundColor = (required: boolean, selected: boolean) => {
  if (required) {
    return THEME.COLORS.SECONDARY;
  }
  if (selected) {
    return THEME.COLORS.ACCENT;
  }

  return THEME.COLORS.LIGHT_GREY;
};

export const ChipContainer = styled.div<{selected: boolean, required: boolean}>`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${THEME.SPACING.MEDIUM};
  border-radius: ${THEME.RADIUS.BASE};
  background-color: ${({ selected, required }) => getBackgroundColor(required, selected)};
  color: ${({ selected, required }) => (selected || required ? THEME.COLORS.PURE_WHITE : THEME.COLORS.CONTENT_A)};
  cursor: pointer;
  :hover {
    background-color: ${({ selected }) => (selected ? THEME.COLORS.PRIMARY : THEME.COLORS.ACCENT)};
    color: ${THEME.COLORS.PURE_WHITE};
  };
  transition: all .3s ease;
`;

export const ChipTitle = styled.span`
  ${Subtitle1Font};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 40px; 
  vertical-align: middle;
  @media (max-height: ${THEME.BREAKPOINTS.HEIGHT.SMALL}px) {
    ${Subtitle2Font};
  }
`;

export const IconBaseCss = css`
  fill: ${THEME.COLORS.PURE_WHITE};
  width: 16px;
  height: 16px;
  margin: 0 10px 0 0;
`;

export const CheckedChipIcon = styled(ASSETS.CHECKED_GHOST)`
  ${IconBaseCss};
`;

export const RequiredChipIcon = styled(ASSETS.ASTERISK)`
  ${IconBaseCss};
`;

export const CloseChipIcon = styled(ASSETS.CLOSE_CHIP)`
  ${IconBaseCss};
`;
